import { render } from "./DetailDiff.vue?vue&type=template&id=2b2f24d4"
import script from "./DetailDiff.vue?vue&type=script&lang=js"
export * from "./DetailDiff.vue?vue&type=script&lang=js"

import "./DetailDiff.vue?vue&type=style&index=0&id=2b2f24d4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__